require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/object/define-property.js
// module id = 1142
// module chunks = 168707334958949